module.exports = __webpack_public_path__ + "public/img/xm20190118_03.dae9ddc6.png";